module.exports = __webpack_public_path__ + "img/concept.49a0d680.svg";